module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("4Vmeb"))).then(() => parcelRequire('9Lwss'));